import React from "react";
import { toast } from "react-toastify";
import i18n from "../../i18n";

export const MERGED_LINKS_HEADER = "x-offolio-merged-links";

export const mergedLinksFromHeaders = (headers) => {
  const count = Number(headers?.[MERGED_LINKS_HEADER] ?? 0);
  return Number.isFinite(count) ? count : 0;
};

/**
 * PDR-0047: an import keeps one link per pair of activities, the most constraining, until the
 * Gantt shows several. The warning stays until closed, so the planner can fetch the details.
 */
export const notifyMergedLinks = (count, onDownloadDetails) => {
  if (!count) return null;
  return toast.warning(
    <div data-testid="merged-links-toast">
      <div>{i18n.t("importWarnings.mergedLinks", { count })}</div>
      {onDownloadDetails && (
        <button
          type="button"
          className="btn btn-link p-0"
          data-testid="merged-links-download"
          onClick={onDownloadDetails}
        >
          {i18n.t("importWarnings.downloadDetails")}
        </button>
      )}
    </div>,
    { autoClose: false, toastId: "merged-links" }
  );
};
